import { forwardRef, PropsWithChildren } from 'react';
import clsx from 'clsx';

import classes from './styles.module.scss';

interface Props {
    className?: string;
    hideX?: boolean;
    hideY?: boolean;
}

const ScrollableView = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => {
    const { children, hideX = false, hideY = false, className } = props;
    // Note that for vertical scroll:
    // the child should not have a fixed '100%' height so
    // it can not have height==='100%' or maxHeight==='100%'
    // just you can set minHeight==='100%' if your component wants
    // to fill whole vertical space

    // Note that for horizontal scroll:
    // the child should not have a fixed '100%' width so
    // it can not have width==='100%' or maxWidth==='100%'
    // just you can set minWidth==='100%' if your component wants
    // to fill whole vertical space
    return (
        <div
            ref={ref}
            className={clsx(
                classes.root,
                {
                    [classes.xHidden]: hideX,
                    [classes.yHidden]: hideY,
                },
                className
            )}
        >
            {children}
        </div>
    );
});

export default ScrollableView;
